import { useTranslation } from "react-i18next";
import { Box, Divider, makeStyles, Paper, Typography } from "@material-ui/core";
import { alpha } from "@material-ui/core/styles";
import MemoryIcon from "@material-ui/icons/Memory";
import ProviderCard from "./ProviderCard";

import { AIProvider } from "@dashboard-v3/api";

interface Props {
  providers: AIProvider[];
  onSelect: (providerId: string) => void;
}

export default function EmptyState({ providers, onSelect }: Props) {
  const { t } = useTranslation("storage");
  const classes = useStyles();

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      textAlign="center"
      padding="44px 30px"
      component={Paper}
    >
      <div className={classes.iconContainer}>
        <MemoryIcon className={classes.icon} />
      </div>
      <Typography variant="h6" className={classes.title}>
        {t("externalAI.empty.title")}
      </Typography>
      <Typography
        variant="body2"
        color="textSecondary"
        className={classes.description}
      >
        {t("externalAI.empty.description")}
      </Typography>
      <Divider className={classes.divider} />
      <Typography
        variant="overline"
        color="textSecondary"
        className={classes.chooseLabel}
      >
        {t("externalAI.empty.chooseProvider")}
      </Typography>
      <div className={classes.providers}>
        {providers.map(provider => (
          <ProviderCard
            key={provider.id}
            provider={provider}
            onSelect={onSelect}
          />
        ))}
      </div>
    </Box>
  );
}

const useStyles = makeStyles(theme => ({
  iconContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: 64,
    height: 64,
    marginBottom: 16,
    borderRadius: "50%",
    backgroundColor: alpha(theme.palette.primary.main, 0.08),
    color: theme.palette.primary.main,
  },
  icon: { fontSize: 32 },
  title: { marginBottom: 8, fontWeight: 500 },
  description: { maxWidth: 520, lineHeight: 1.6 },
  divider: { width: "100%", maxWidth: 900, marginTop: 28 },
  chooseLabel: { marginTop: 20, marginBottom: 12 },
  providers: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(190px, 1fr))",
    gap: 12,
    width: "100%",
    maxWidth: 900,
  },
}));
